export default __webpack_public_path__ + "static/media/Logo_Epimed.03022590.svg";